// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"c529dcd0","344":"611d6ebc","536":"9d5cba73","543":"4c96f1e2"}[chunkId] + ".chunk.css";
};